import React from "react";
import { Row, Col } from 'react-bootstrap';
import { IDinningAmenityData } from "../../types/api/dinningApi";
import { NoData } from "../common/NoData";
import icon from '../../assets/images/hotel.png';
import { useTranslation } from "react-i18next";

const DinningCard: React.FC<{ dinning_ameniti: Array<IDinningAmenityData> }> = ({ dinning_ameniti }) => {
    const {t} = useTranslation()
const dinning_ameniti_json = t('dinning.dinning_ameniti', { returnObjects: true })  as string[];

    return (
        <div>
            <div>
                <section className="dinningcard-section">
                    <div className="container">
                        <Row className="row">
                            {
                                dinning_ameniti && dinning_ameniti.length > 0 ?
                                    dinning_ameniti.map((aminity: IDinningAmenityData, index: number) => (
                                        <Col md={4} key={"Dining_Aminity_" + index}>
                                            <div className="dinning-card">
                                                <div className="card-img">
                                                    <img src={aminity.image} alt="img" className="img-fluid" />
                                                </div>
                                                <div className="card-content">
                                                    <div className="icon">
                                                        {/* <img src={aminity.icon} alt="icon" className="img-fluid" /> */}
                                                        <img src={icon} alt="icon" className="img-fluid"></img>
                                                    </div>
                                                    <div className="card-text">
                                                        <h5 className="title">{dinning_ameniti_json && dinning_ameniti_json.length>0 && dinning_ameniti_json[index]}</h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    ))
                                    : <NoData message="Oops, No Dining Amininty Data Found!!" />
                            }
                        </Row>
                    </div>
                </section>
            </div>
        </div>
    )
}
export default DinningCard;